export default class Testimonial {
  id: number;
  name: string;
  title: string;
  message: string;
  image: string;

  constructor(entity: Testimonial) {
    this.id = entity.id;
    this.name = entity.name;
    this.title = entity.title;
    this.message = entity.message;
    this.image = entity.image;
  }
}



// WEBPACK FOOTER //
// ./src/entities/Testimonial.tsx